import React, { useEffect } from 'react';
import Card from '@mui/material/Card';
import { Button } from '@mui/material';
import { Hidden } from "@material-ui/core";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { useSelector, useDispatch } from 'react-redux';
import {
  getChangePassword, setBizID, setStyle, setBusinessName, setLogo, getLogo, getStyle, getBizName, setAuthen, setRoles, setServices
} from "../../libs/todoSlice"
import fontColor from '../../lib/fontColor';
import Cookie from '../../lib/Cookie';
import { logoutSession } from '../../lib/logoutRedirect';
function VerifySuccess() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const businessName = useSelector(getBizName)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  const changepass = useSelector(getChangePassword)
  const params = useParams()
  const [cookie, setCookie, removeCookie] = useCookies(['new_user', 'account', 'cookie_consent_accepting'])
  useEffect(() => {
    recheck()
    getPrefixDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getPrefixDetail = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
    }).then(({ data, status }) => {
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        dispatch(setServices({
          services: data.data.services
        }))
      }
      getLogoApi(data.data.businessID)
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    }, ({ response }) => {
    })
  }
  const getLogoApi = async (bizid) => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${bizid}`,
    }).then(({ data, status }) => {
      dispatch(setLogo({
        logo: data.data
      }))
    }, () => {

    })
  }
  const recheck = async () => {
    await axios({
      method: 'GET',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/loalevel`,
    }).then(({ data }) => {
      // if(cookie.cookie_consent_accepting){
      setCookie('new_user', {
        ...cookie.new_user,
        confirmed_email: data.data.confirmed,
      }, {
        path: '/',
        expires: new Date(Date.now() + 3600000),
        // httpOnly: true
      })
      if (changepass) {
        navigate(`/${params.prefix}/manage-members`)
      }
      // }

    }, ({ response }) => {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    })
  }
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };
  return (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img src={`data:image/png;base64, ${logo}`} alt=""
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
          }} />
        <span
          style={{
            fontWeight: '600',
            color: '#000',
            padding: '10px',
          }}
        >{businessName}</span>
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              borderRadius: '6px',
              float: 'right',
              color: fontColor(style.secondary_color),
              background: style.secondary_color,
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 40px',
          gap: '36px',
        }}
      >
        <div style={{ zIndex: '1' }}>
          <Card
            style={{
              width: '467px',
              background: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '32px',
              padding: '60px 40px',
              color: '#053075'
            }}
          >
            <div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <VerifiedUserIcon style={{ width: '48px', height: '48px' }} />
              </div>
              <div>
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontWeight: '700',
                    fontSize: '18px',
                    lineHeight: '50px',
                    letterSpacing: '0.02em',
                  }}>ทำการยืนยันตัวตนเรียบร้อยแล้ว</span>
              </div>
              <div style={{ marginTop: '20px' }}>
                <Button
                  style={{
                    width: '387px',
                    height: '36px',
                    // background: '#F6911F',
                    borderRadius: '6px',
                    // color: 'white',
                    textTransform: 'none',
                    color: fontColor(style.secondary_color),
                    background: style.secondary_color,
                  }}
                  onClick={() => {
                    navigate(`/${params.prefix}/login-user/change-password`)
                  }}
                >
                  ดำเนินการต่อ
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default VerifySuccess